import React from 'react';
import { StageSection, Prose, FactGrid } from '../../ContentPrimitives';
import { StageBlock, content, question } from '../../types';

export const meta = {
    title: 'Validators, Clusters & Anchor',
    tagline: 'Where this all runs, and the framework that makes it easier to build on.',
};

// This stage expects 2 quiz questions configured in the admin panel, in this order:
//   Q0 - what Anchor actually is (a framework reducing boilerplate, not a different chain/consensus)
//   Q1 - what distinguishes Devnet/Testnet from Mainnet Beta
export const blocks: StageBlock[] = [
    content('clusters', () => (
        <StageSection gradientBorder eyebrow="Stage 8 of 8" title="Clusters: separate networks of validators">
            <Prose>
                A cluster is a set of validators working together toward consensus on one shared ledger. Solana
                runs several clusters for different purposes.
            </Prose>
            <FactGrid items={[
                ['Mainnet Beta', 'The production network: real SOL, real economic value at stake.'],
                ['Devnet', 'For active development, with free (worthless) SOL from a faucet for testing.'],
                ['Testnet', 'Used to stress-test upcoming validator software changes under realistic load.'],
            ]} />
        </StageSection>
    )),

    content('anchor', () => (
        <StageSection title="Anchor: the same model, a lot less boilerplate">
            <Prose>
                Writing programs directly against Solana's native APIs means manually serializing account data and
                manually checking account relationships (is this the right owner? the right signer? the right
                size?) by hand. Anchor is a framework that generates most of that boilerplate for you, letting
                developers declare the constraints an account must satisfy and let the framework enforce them.
            </Prose>
            <Prose>
                Anchor doesn't change any of the concepts from this track: accounts, ownership, instructions, CPI,
                and consensus all still work exactly the way they've been described here. It just removes a lot of
                repetitive, error-prone code and, done carelessly, introduces its own class of mistakes, which is
                exactly what the dedicated Anchor tracks and their security categories dig into.
            </Prose>
        </StageSection>
    )),

    question(0),

    content('closing', () => (
        <StageSection title="What comes next">
            <Prose>
                Everything in this track (accounts as the universal container for state, programs as stateless
                code, instructions that declare their accounts upfront, ownership as a hard boundary, CPI, and the
                consensus that orders it all) is the foundation the Solana Foundation, Advanced, and Anchor tracks
                build on directly.
            </Prose>
        </StageSection>
    )),

    question(1),
];
